module.exports = __webpack_public_path__ + "img/aero.606a7b76.jpg";